import { useEffect, useState } from "react";
import BankLst from "./bank-lst";
import Pagination from "../../../common/pagination";
import http from "../../../../helpers/http";
import { doObjToFormData } from "../../../../helpers/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function BankBlk({ items, deletePaymentMethod, isPaymentMethodDeleted }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [paymentMethods, setPaymentMethods] = useState([]);
    useEffect(() => {
      setPaymentMethods(items);
    }, [])
    
    const [itemsPerPage] = useState(12);

    //get Current posts
    const indexOfLastPost = currentPage * itemsPerPage;
    const indexOfFirstPost = indexOfLastPost - itemsPerPage;
    const currentItems = paymentMethods?.slice(indexOfFirstPost, indexOfLastPost);
    const [isPaymentMethodDefault, setIsPaymentMethodDefault] = useState(false)
    // const paginate = (pageNumber) => setCurrentPage(pageNumber);
    function paginate(pageNumber) {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 3)
    }
    const navigate = useNavigate();
    const handleChangeDefaultPaymentMethod = (payment_method_id) => {
        if(payment_method_id) {
            setIsPaymentMethodDefault(true)
            http
                .post("change-payment-method-default/"+payment_method_id,doObjToFormData({ payment_method_id }))
                .then(({ data }) => {
                    setIsPaymentMethodDefault(false);
                    if(data?.status===1){
                        toast.success(data?.msg); 
                        setPaymentMethods(data?.bank_accounts)
                    }
                    else{
                        toast.error(data?.msg);
                    }
                })
                .catch((error) => {
                    console.log(error)
                    setIsPaymentMethodDefault(false);
                    toast.error(error?.response?.data?.msg || "Technical error changing default payment method");
                });
        }
        
    };
    return (
        <div id="bank" className="tab-pane fade a active in">
            <div className="outer_list bank_show_listing">
                {
                    isPaymentMethodDefault &&
                    <div className="loadingDisabled">
                        <i className="spinner"></i>
                    </div>
                }
                {
                    currentItems && currentItems?.length > 0 ?
                        currentItems?.map((item, index) => {
                            return (
                                <BankLst item={item} key={index} deletePaymentMethod={deletePaymentMethod} isPaymentMethodDeleted={isPaymentMethodDeleted} handleChangeDefaultPaymentMethod={handleChangeDefaultPaymentMethod} isPaymentMethodDefault={isPaymentMethodDefault} />
                            )
                        })
                        :
                        <div className="alert alert-danger">No bank accounts added yet!</div>
                }
            </div>
            <Pagination paginate={paginate} itemsPerPage={itemsPerPage} totalItems={paymentMethods?.length} currentPage={currentPage} />
        </div>
    );
}